export class ConvertFileSize {
  static MBtoBytes = (mb: number) => mb * 1024 * 1024;
}
